import { gql } from '@apollo/client';

export const QUERY_ME = gql`
  query users($id: ID!) {
    usersPermissionsUser(id: $id) {
      data {
        attributes {
          topics {
            data {
              attributes {
                topic
              }
            }
          }
        }
      }
    }
  }
`;

// export const QUERY_NOTIFICATION_PREFERENCES_ME = gql`
//   query findNotificationPreferences($id: ID!) {
//     notificationPreferences(filters: { user: { id: { eq: $id } } }) {
//       data {
//         attributes {
//           createdAt
//         }
//       }
//     }
//   }
// `;
